module.exports = __webpack_public_path__ + "img/Professional-2.ee1c802e.png";